import React from 'react';
import { useTranslation } from 'react-i18next';

const ReviewJobsPage = () => {
  const { t } = useTranslation();

  return (
    <div className="page-container support-dashboard">
      <h1>{t('review_jobs', 'İncelemedeki İşler')}</h1>
      <p>{t('page_under_construction', 'Bu sayfa yapım aşamasındadır.')}</p>
      {/* Gelecekte buraya, /api/support/jobs/in-review endpoint'inden gelen
          işleri listeleyen ve "Onayla ve Bitir" butonu olan bir tablo gelecek. */}
    </div>
  );
};

export default ReviewJobsPage;